module.exports = __webpack_public_path__ + "img/clothing.507a22ad.png";